import { Editor } from '@tiptap/core';
import React from 'react';

import { Button } from '@/ui/Button';
import { Icon } from '@/ui/Icon';
import { cn } from '@/utils';

interface BoldMenuItemProps {
	editor: Editor | null;
}

const BoldMenuItem = (props: BoldMenuItemProps) => {
	const { editor } = props;

	if (!editor) {
		return null;
	}

	return (
		<Button
			onClick={() => editor.chain().focus().toggleBold().run()}
			disabled={!editor.can().chain().focus().toggleBold().run()}
			className={cn('w-6 h-6 text-brand-gray-2 [&>svg]:reset [&>svg]:size-6 p-0 [&>svg]:left-[0px]', {
				'text-brand-blue': editor.isActive('bold'),
			})}
			size="icon"
			icon="left"
			variant="tetriary"
		>
			<Icon name="bold" size={24} />
		</Button>
	);
};

export { BoldMenuItem };
